import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ReactSVG } from 'react-svg';
import { Avatar, Box, CircularProgress, Collapse, IconButton, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { KeyboardArrowDown, KeyboardArrowUp, RadioButtonUnchecked } from '@mui/icons-material';

import { getStyles } from './styles';
import { IconSvg } from '../../../utils/globalIcons';
import { useAppContext } from '../../../context/AppContext';

function ExtractionHome() {

    const theme = useTheme();
    const styles = getStyles(theme);
    const navigate = useNavigate();
    const [stepIndex, setStepIndex] = useState(null);
    const { guideDataloading, extractionGuideData, handleExtractionSteps } = useAppContext();

    const handleServiceGuide = (type) => {
        try {

            if (type === "upload_data_via_api_completed") {
                handleExtractionSteps('upload_data_via_api_completed')
                const upload_api_path = window.__ENV__.DOCYRUS_URL
                window.open(upload_api_path, "_blank");
                return
            }

            if (type === "get_data_via_api_completed") {
                handleExtractionSteps('get_data_via_api_completed')
                const get_api_path = window.__ENV__.DOCYRUS_URL
                window.open(get_api_path, "_blank");
                return
            }

            const navigationMap = {
                is_first_doc_uploaded: "/document-types/add",
                review_extracted_fields_completed: "/document-types",
                upload_5_docs_status: "/all-documents",
                is_review_extracted_data_done: "/all-documents",
            };

            const path = navigationMap[type] || "/extraction-home";
            navigate(path);

        } catch (error) {
            console.error(error);
        }
    };

    return (
        <div style={styles.mainContainer}>
            <Box sx={styles.cardContainer}>
                <Box marginTop={'50px'}>

                    <Typography sx={{ fontSize: '20px', fontWeight: 700 }}>Welcome to Ameya Extract</Typography>
                    <Typography sx={{ fontSize: '14px', fontWeight: 400, marginTop: '10px' }}>
                        Unlock data from your documents: Learn the basics, build a model, and start extracting.
                    </Typography>

                    {guideDataloading ?
                        (<Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '90px' }}>
                            <CircularProgress />
                        </Box>)
                        :
                        (<Box>
                            <Box marginTop={'40px'}>

                                <Box sx={{
                                    display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                                    padding: '15px', backgroundColor: '#ffffff',
                                    borderTopLeftRadius: '10px',
                                    borderTopRightRadius: '10px',
                                    borderBottomLeftRadius: stepIndex === 1 ? '0px' : '10px',
                                    borderBottomRightRadius: stepIndex === 1 ? '0px' : '10px',
                                    border: '1px solid #DEDEDE'
                                }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                        <Avatar
                                            sx={{ bgcolor: '#0B51C5', height: '32px', width: '32px' }}
                                            alt="Remy Sharp"
                                        >
                                            1
                                        </Avatar>
                                        <Typography sx={{ fontSize: '16px', fontWeight: 600, marginLeft: '10px' }}>
                                            Create your first document type AI model
                                        </Typography>
                                    </Box>

                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                        {(extractionGuideData.is_first_doc_uploaded && extractionGuideData.review_extracted_fields_completed) && (
                                            <ReactSVG src={IconSvg.check3Icon}
                                                beforeInjection={(svg) => {
                                                    svg.setAttribute('style', 'width: 24px; height: 24px; display: block;');
                                                }}
                                            />
                                        )}

                                        <IconButton
                                            sx={{ fontSize: '16px', fontWeight: 600, marginLeft: '10px' }}
                                            onClick={() => setStepIndex(stepIndex === 1 ? null : 1)}
                                        >
                                            {stepIndex === 1 ? <KeyboardArrowUp sx={{ color: '#0B51C5' }} /> : <KeyboardArrowDown sx={{ color: '#0B51C5' }} />}
                                        </IconButton>
                                    </Box>
                                </Box>

                                <Collapse in={stepIndex === 1} timeout="auto" unmountOnExit
                                    sx={{
                                        backgroundColor: '#FFFFFF',
                                        borderBottomLeftRadius: '10px',
                                        borderBottomRightRadius: '10px',
                                        border: '1px solid #DEDEDE',
                                        borderTop: stepIndex === 1 && 0
                                    }}
                                >

                                    <Box sx={{ padding: '20px' }}>
                                        <Box
                                            sx={{
                                                display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                                                padding: '10px', backgroundColor: '#ffffff', borderRadius: '10px', border: '1px solid #DEDEDE'
                                            }}
                                        >
                                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                {extractionGuideData.is_first_doc_uploaded
                                                    ?
                                                    (<ReactSVG
                                                        src={IconSvg.check2Icon}
                                                        beforeInjection={(svg) => {
                                                            svg.setAttribute('style', 'width: 24px; height: 24px; display: block;');
                                                        }}
                                                    />)
                                                    : (<RadioButtonUnchecked sx={{ width: 24, height: 24, color: '#C4C4C4' }} />)
                                                }
                                                <Typography sx={{ fontSize: '14px', fontWeight: 500, marginLeft: '10px' }}>
                                                    Select a document type and upload your first document
                                                </Typography>
                                            </Box>
                                            <Typography
                                                onClick={() => handleServiceGuide('is_first_doc_uploaded')}
                                                sx={{
                                                    color: '#0B51C5',
                                                    fontSize: '12px',
                                                    fontWeight: '600',
                                                    cursor: 'pointer',
                                                    '&:hover': { textDecoration: 'underline' }
                                                }}
                                            >
                                                UPLOAD
                                            </Typography>
                                        </Box>

                                        <Box
                                            sx={{
                                                display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '10px',
                                                padding: '10px', backgroundColor: '#ffffff', borderRadius: '10px', border: '1px solid #DEDEDE'
                                            }}
                                        >
                                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                {extractionGuideData.review_extracted_fields_completed
                                                    ?
                                                    (<ReactSVG
                                                        src={IconSvg.check2Icon}
                                                        beforeInjection={(svg) => {
                                                            svg.setAttribute('style', 'width: 24px; height: 24px; display: block;');
                                                        }}
                                                    />)
                                                    : (<RadioButtonUnchecked sx={{ width: 24, height: 24, color: '#C4C4C4' }} />)
                                                }
                                                <Typography sx={{ fontSize: '14px', fontWeight: 500, marginLeft: '10px' }}>
                                                    Review extracted fields and configure
                                                </Typography>
                                            </Box>

                                            <Typography
                                                onClick={() => handleServiceGuide('review_extracted_fields_completed')}
                                                sx={{
                                                    color: '#0B51C5',
                                                    fontSize: '12px',
                                                    fontWeight: '600',
                                                    cursor: 'pointer',
                                                    '&:hover': { textDecoration: 'underline' }
                                                }}
                                            >
                                                CONFIGURE
                                            </Typography>
                                        </Box>
                                    </Box>
                                </Collapse>

                            </Box>

                            <Box marginTop={'30px'}>

                                <Box sx={{
                                    display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                                    padding: '15px', backgroundColor: '#ffffff',
                                    borderTopLeftRadius: '10px',
                                    borderTopRightRadius: '10px',
                                    borderBottomLeftRadius: stepIndex === 2 ? '0px' : '10px',
                                    borderBottomRightRadius: stepIndex === 2 ? '0px' : '10px',
                                    border: '1px solid #DEDEDE'
                                }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                        <Avatar
                                            sx={{ bgcolor: '#0B51C5', height: '32px', width: '32px' }}
                                            alt="Remy Sharp"
                                        >
                                            2
                                        </Avatar>
                                        <Typography sx={{ fontSize: '16px', fontWeight: 600, marginLeft: '10px' }}>
                                            Process documents and review
                                        </Typography>
                                    </Box>

                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                        {(extractionGuideData.upload_5_docs_status && extractionGuideData.is_review_extracted_data_done) &&
                                            <ReactSVG src={IconSvg.check3Icon}
                                                beforeInjection={(svg) => {
                                                    svg.setAttribute('style', 'width: 24px; height: 24px; display: block;');
                                                }}
                                            />
                                        }
                                        <IconButton
                                            sx={{ fontSize: '16px', fontWeight: 600, marginLeft: '10px' }}
                                            onClick={() => setStepIndex(stepIndex === 2 ? null : 2)}
                                        >
                                            {stepIndex === 2 ? <KeyboardArrowUp sx={{ color: '#0B51C5' }} /> : <KeyboardArrowDown sx={{ color: '#0B51C5' }} />}
                                        </IconButton>
                                    </Box>
                                </Box>

                                <Collapse in={stepIndex === 2} timeout="auto" unmountOnExit
                                    sx={{
                                        backgroundColor: '#FFFFFF',
                                        borderBottomLeftRadius: '10px',
                                        borderBottomRightRadius: '10px',
                                        border: '1px solid #DEDEDE',
                                        borderTop: stepIndex === 2 && 0
                                    }}
                                >

                                    <Box sx={{ padding: '20px' }}>
                                        <Box
                                            sx={{
                                                display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                                                padding: '10px', backgroundColor: '#ffffff', borderRadius: '10px', border: '1px solid #DEDEDE'
                                            }}
                                        >
                                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                {extractionGuideData.upload_5_docs_status
                                                    ?
                                                    (<ReactSVG
                                                        src={IconSvg.check2Icon}
                                                        beforeInjection={(svg) => {
                                                            svg.setAttribute('style', 'width: 24px; height: 24px; display: block;');
                                                        }}
                                                    />)
                                                    : (<RadioButtonUnchecked sx={{ width: 24, height: 24, color: '#C4C4C4' }} />)
                                                }
                                                <Typography sx={{ fontSize: '14px', fontWeight: 500, marginLeft: '10px' }}>
                                                    Upload 5 documents
                                                </Typography>
                                            </Box>
                                            <Typography
                                                onClick={() => handleServiceGuide('upload_5_docs_status')}
                                                sx={{ color: '#0B51C5', fontSize: '12px', fontWeight: '600', cursor: 'pointer', '&:hover': { textDecoration: 'underline' } }}
                                            >
                                                UPLOAD
                                            </Typography>
                                        </Box>

                                        <Box
                                            sx={{
                                                display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '10px',
                                                padding: '10px', backgroundColor: '#ffffff', borderRadius: '10px', border: '1px solid #DEDEDE'
                                            }}
                                        >
                                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                {extractionGuideData.is_review_extracted_data_done
                                                    ?
                                                    (<ReactSVG
                                                        src={IconSvg.check2Icon}
                                                        beforeInjection={(svg) => {
                                                            svg.setAttribute('style', 'width: 24px; height: 24px; display: block;');
                                                        }}
                                                    />)
                                                    : (<RadioButtonUnchecked sx={{ width: 24, height: 24, color: '#C4C4C4' }} />)
                                                }
                                                <Typography sx={{ fontSize: '14px', fontWeight: 500, marginLeft: '10px' }}>
                                                    Review extracted data and approve
                                                </Typography>
                                            </Box>
                                            <Typography
                                                onClick={() => handleServiceGuide('is_review_extracted_data_done')}
                                                sx={{ color: '#0B51C5', fontSize: '12px', fontWeight: '600', cursor: 'pointer', '&:hover': { textDecoration: 'underline' } }}>
                                                REVIEW
                                            </Typography>
                                        </Box>
                                    </Box>
                                </Collapse>

                            </Box>

                            <Box marginTop={'30px'}>

                                <Box sx={{
                                    display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                                    padding: '15px', backgroundColor: '#ffffff',
                                    borderTopLeftRadius: '10px',
                                    borderTopRightRadius: '10px',
                                    borderBottomLeftRadius: stepIndex === 3 ? '0px' : '10px',
                                    borderBottomRightRadius: stepIndex === 3 ? '0px' : '10px',
                                    border: '1px solid #DEDEDE'
                                }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                        <Avatar
                                            sx={{ bgcolor: '#0B51C5', height: '32px', width: '32px' }}
                                            alt="Remy Sharp"
                                        >
                                            3
                                        </Avatar>
                                        <Typography sx={{ fontSize: '16px', fontWeight: 600, marginLeft: '10px' }}>
                                            Integrate Ameya Extract with APIs
                                        </Typography>
                                    </Box>

                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>

                                        {(extractionGuideData.upload_data_via_api_completed && extractionGuideData.get_data_via_api_completed) &&
                                            <ReactSVG src={IconSvg.check3Icon}
                                                beforeInjection={(svg) => {
                                                    svg.setAttribute('style', 'width: 24px; height: 24px; display: block;');
                                                }}
                                            />
                                        }
                                        <IconButton
                                            sx={{ fontSize: '16px', fontWeight: 600, marginLeft: '10px' }}
                                            onClick={() => setStepIndex(stepIndex === 3 ? null : 3)}
                                        >
                                            {stepIndex === 3 ? <KeyboardArrowUp sx={{ color: '#0B51C5' }} /> : <KeyboardArrowDown sx={{ color: '#0B51C5' }} />}
                                        </IconButton>
                                    </Box>
                                </Box>

                                <Collapse in={stepIndex === 3} timeout="auto" unmountOnExit
                                    sx={{
                                        backgroundColor: '#FFFFFF',
                                        borderBottomLeftRadius: '10px',
                                        borderBottomRightRadius: '10px',
                                        border: '1px solid #DEDEDE',
                                        borderTop: stepIndex === 3 && 0
                                    }}
                                >

                                    <Box sx={{ padding: '20px' }}>
                                        <Box
                                            sx={{
                                                display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                                                padding: '10px', backgroundColor: '#ffffff', borderRadius: '10px', border: '1px solid #DEDEDE'
                                            }}
                                        >
                                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                {extractionGuideData.upload_data_via_api_completed
                                                    ?
                                                    (<ReactSVG
                                                        src={IconSvg.check2Icon}
                                                        beforeInjection={(svg) => {
                                                            svg.setAttribute('style', 'width: 24px; height: 24px; display: block;');
                                                        }}
                                                    />)
                                                    : (<RadioButtonUnchecked sx={{ width: 24, height: 24, color: '#C4C4C4' }} />)
                                                }
                                                <Typography sx={{ fontSize: '14px', fontWeight: 500, marginLeft: '10px' }}>
                                                    Upload via API
                                                </Typography>
                                            </Box>
                                            <Typography
                                                onClick={() => handleServiceGuide('upload_data_via_api_completed')}
                                                sx={{ color: '#0B51C5', fontSize: '12px', fontWeight: '600', cursor: 'pointer', '&:hover': { textDecoration: 'underline' } }}
                                            >
                                                LEARN
                                            </Typography>
                                        </Box>

                                        <Box
                                            sx={{
                                                display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '10px',
                                                padding: '10px', backgroundColor: '#ffffff', borderRadius: '10px', border: '1px solid #DEDEDE'
                                            }}
                                        >
                                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                {extractionGuideData.get_data_via_api_completed
                                                    ?
                                                    (<ReactSVG
                                                        src={IconSvg.check2Icon}
                                                        beforeInjection={(svg) => {
                                                            svg.setAttribute('style', 'width: 24px; height: 24px; display: block;');
                                                        }}
                                                    />)
                                                    : (<RadioButtonUnchecked sx={{ width: 24, height: 24, color: '#C4C4C4' }} />)
                                                }
                                                <Typography sx={{ fontSize: '14px', fontWeight: 500, marginLeft: '10px' }}>
                                                    Get extracted data via API
                                                </Typography>
                                            </Box>
                                            <Typography
                                                onClick={() => handleServiceGuide('get_data_via_api_completed')}
                                                sx={{ color: '#0B51C5', fontSize: '12px', fontWeight: '600', cursor: 'pointer', '&:hover': { textDecoration: 'underline' } }}
                                            >
                                                LEARN
                                            </Typography>
                                        </Box>
                                    </Box>
                                </Collapse>

                            </Box>
                        </Box>
                        )
                    }


                </Box>
            </Box>
        </div >

    )
}

export default ExtractionHome;